module.exports = __webpack_public_path__ + "img/universkin-m-icon.aabb85bb.svg";